import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import PageMeta from '@/components/SEO/PageMeta';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="Page non trouvée - La Patrimoniale"
        description="La page demandée est introuvable. Rejoignez La Patrimoniale, votre cabinet expert en gestion de patrimoine à Paris, pour bénéficier d’un accompagnement personnalisé en optimisation fiscale, investissement et gestion patrimoniale. Naviguez vers l'accueil ou contactez un conseiller La Patrimoniale."
        keywords="La Patrimoniale, page non trouvée, erreur 404 La Patrimoniale, gestion patrimoine Paris, contact La Patrimoniale, conseil patrimonial, expert gestion patrimoine"
        noIndex={true}
      />
      <Navbar />
      <main className="flex-grow flex items-center justify-center py-16">
        <div className="max-w-md mx-auto text-center px-4">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-gray-100 p-4">
              <FileQuestion className="h-16 w-16 text-patrimoine-DEFAULT" />
            </div>
          </div>
          <h1 className="text-3xl font-bold mb-4 text-patrimoine-dark">Page non trouvée</h1>
          <p className="text-patrimoine-muted mb-8">
            La page que vous recherchez n'existe pas ou a été déplacée. 
            Utilisez le menu de navigation ou retournez à l'accueil.
          </p>
          <div className="space-y-3">
            <Link to="/">
              <Button className="w-full bg-patrimoine-DEFAULT hover:bg-patrimoine-dark text-white">
                Retourner à l'accueil
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="w-full">
                Nous contacter
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
